(function() {
  "use strict";
  angular.module("app")
    .component('datePicker', {
      template: '<angular-date-picker on-change="vm.handleOnChange" date="vm.ngModel.$viewValue" mode="vm.mode" format="vm.format" display-format="vm.displayFormat" disabled="vm.disabled" width="vm.width" container-id="vm.containerId"></angular-date-picker>',
      require: {
        ngModel: '^ngModel',
      },
      bindings: {
        mode: '@',
        format: '@',
        displayFormat: '@',
        disabled: '=',
        width: '@',
        onChange: "&?",
        containerId: '@'
      },
      controllerAs: 'vm',
      controller: function() {
        const vm = this
        vm.handleOnChange = (value) => {
          vm.ngModel.$setViewValue(value)
          if (vm.onChange) {
            vm.onChange()
          }
        }
      }
    })
})()
